<template>
    <div>
        <escenario-opcion-componente nombre="Uso"
                                     descripcion="Identifica la ubicación del pavimento a instalar.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                    :escenario="escenario"
                    campo-id="code"
                    campo-nombre="name"
                    campo-descripcion="description"
                    :opciones="usos"
                    propiedad="use"
                    descripcion="Seleccionar uso"
                    @change="seleccionarUso">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Intensidad de tránsito"
                                     descripcion="Identifica la cantidad de tráfico peatonal sobre el pavimento.">
            <template v-slot:seleccion>
                <div class="font-italic font-weight-bold pa-2 caption" v-if="escenario && escenario.use == null">
                    Se debe seleccionar el uso antes
                </div>
                <escenario-seleccion-componente
                    v-if="escenario && escenario.use != null"
                    :escenario="escenario"
                    campo-id="code"
                    campo-nombre="name"
                    campo-descripcion="description"
                    :opciones="intensidadesTransitoSeleccion"
                    propiedad="trafficIntensity"
                    descripcion="Seleccionar intensidad tránsito"
                    @change="seleccionarIntensidadTransito">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Tipo de local"
                                     descripcion="Identifica si existen necesidades especiales de seguridad debido a la presencia de humedad.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                    :escenario="escenario"
                    campo-id="code"
                    campo-nombre="name"
                    campo-descripcion="description"
                    :opciones="tipoLocales"
                    propiedad="localType"
                    descripcion="Seleccionar tipo local"
                    @change="seleccionarTipoLocal">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Necesidades especiales de higiene"
                                     descripcion="Puede aplicarse a cualquiera de los usos y repercute en los indicadores prestacionales (resitencia a las manchas y química).">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                    :escenario="escenario"
                    campo-id="code"
                    campo-nombre="name"
                    :opciones="necesidadesHigiene"
                    propiedad="needsHygiene"
                    descripcion="Seleccionar necesidades higiene"
                    @change="seleccionarNecesidadHigiena">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Frecuencia de mantenimiento"
                                     descripcion="Engloba las operaciones de limpieza, reparación y sustitución del pavimento. Más información en la zona de Descargas.">
            <template v-slot:seleccion>
                <div class="font-italic font-weight-bold pa-2 caption" v-if="escenario && escenario.use == null">
                    Se debe seleccionar el uso antes
                </div>
                <escenario-seleccion-componente
                    v-if="escenario && escenario.use != null"
                    :escenario="escenario"
                    campo-id="code"
                    campo-nombre="name"
                    campo-descripcion="description"
                    :opciones="frecuenciasMantenimientoSeleccion"
                    propiedad="maintenanceFrequency"
                    descripcion="Seleccionar frecuencia mantenimiento"
                    @change="seleccionarFrecuenciaMantenimiento">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Revestimiento existente"
                                     descripcion="Identifica el tipo de pavimento instalado que se desea renovar">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                    :escenario="escenario"
                    campo-id="code"
                    campo-nombre="name"
                    :opciones="revestimientosExistente"
                    propiedad="existingCoating"
                    descripcion="Seleccionar revestimiento"
                    @change="seleccionarRevestimiento">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>
    </div>
</template>

<script>
    import {HttpHelper} from "../../../../../comunes/helpers/HttpHelper";
    import EscenarioOpcionComponente from "./Componentes/EscenarioOpcionComponente";
    import EscenarioSeleccionComponente from "./Componentes/EscenarioSeleccionComponente";

    export default {
        name: "EscenarioHorizontalRehabilitacion",
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            escenario: {type: Object, required: true},
            correcto: {type: Boolean, default: false}
        },
        components: {
            EscenarioOpcionComponente,
            EscenarioSeleccionComponente
        },
        data: function () {
            return {
                usos: [],
                tipoLocales: [],
                frecuenciasMantenimientoSeleccion: [],
                frecuenciasMantenimiento: [],
                frecuenciasMantenimientoActivadas: [],
                necesidadesHigiene: [],
                intensidadesTransitoSeleccion: [],
                intensidadesTransito: [],
                intensidadesTransitoActivadas: [],
                revestimientosExistente: []
            }
        },
        mounted() {
            Promise.all([
                this.obtenerUsos(),
                this.obtenerTipoLocales(),
                this.obtenerFrecuenciaMantenimiento(),
                this.obtenerNecesidadesHigiene(),
                this.obtenerIntensidadesTransito(),
                this.obtenerRevestimientosExistentes(),
            ]).then(() => {
                this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
            });
        },
        watch: {
            escenario: {
                handler(val) {
                    this.emitirCorrecto(this.escenarioEsCorrecto(val));
                },
                deep: true
            }
        },
        methods: {
            obtenerUsos() {
                return new Promise(resolve => {
                    HttpHelper.get("rehabilitacion/horizontal/uso")
                        .then(data => {
                            this.usos = data;
                            resolve();
                        });
                });
            },
            obtenerTipoLocales() {
                return new Promise(resolve => {
                    HttpHelper.get("rehabilitacion/horizontal/tipo-local").then(data => {
                        this.tipoLocales = data;
                        resolve();
                    });
                });
            },
            obtenerFrecuenciaMantenimiento() {
                return new Promise(resolve => {
                    HttpHelper.get("rehabilitacion/horizontal/frecuencia-mantenimiento")
                        .then(data => {
                            this.frecuenciasMantenimiento = data;
                            resolve();
                            this.obtenerFrecuenciasMantenimientoActivadas();
                        });
                });

            },
            obtenerFrecuenciasMantenimientoActivadas() {
                return new Promise(resolve => {
                    this.frecuenciasMantenimientoActivadas = [];

                    if (this.escenario && this.escenario.use == null) resolve();

                    let url = "rehabilitacion/horizontal/frecuencia-mantenimiento/por-uso/" + this.escenario.use.code;
                    HttpHelper.get(url)
                        .then(data => {
                            data.forEach((type) => {
                                this.frecuenciasMantenimientoActivadas.push(type.code)
                            });
                            this.frecuenciasMantenimientoSeleccion = [];
                            this.frecuenciasMantenimiento.forEach((fm) => {
                                if (this.frecuenciasMantenimientoActivadas.includes(fm.code)) {
                                    this.frecuenciasMantenimientoSeleccion.push(fm);
                                }
                            });
                            if (this.escenario.maintenanceFrequency != null &&
                                !this.frecuenciasMantenimientoActivadas.includes(this.escenario.maintenanceFrequency.code))
                                this.escenario.maintenanceFrequency = null;
                            resolve();
                            if (this.escenario.maintenanceFrequency != null)
                                this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
                        });
                });
            },
            obtenerNecesidadesHigiene() {
                return new Promise(resolve => {
                    HttpHelper.get("rehabilitacion/horizontal/necesidades-higiene")
                        .then(data => {
                            this.necesidadesHigiene = data;
                            resolve();
                        });
                });
            },
            obtenerIntensidadesTransito() {
                return new Promise(resolve => {
                    HttpHelper.get("rehabilitacion/horizontal/intensidad-transito")
                        .then(data => {
                            this.intensidadesTransito = data;
                            resolve();
                            this.obtenerIntensidadesTransitoActivadas();
                        });
                });
            },
            obtenerIntensidadesTransitoActivadas() {
                return new Promise(resolve => {
                    this.intensidadesTransitoActivadas = [];

                    if (!this.escenario || (this.escenario && this.escenario.use == null)) resolve();
                    HttpHelper.get("rehabilitacion/horizontal/intensidad-transito/por-uso/" + this.escenario.use.code)
                        .then(data => {
                            data.forEach((type) => {
                                this.intensidadesTransitoActivadas.push(type.code)
                            });
                            this.intensidadesTransitoSeleccion = [];
                            this.intensidadesTransito.forEach((fm) => {
                                if (this.intensidadesTransitoActivadas.includes(fm.code)) {
                                    this.intensidadesTransitoSeleccion.push(fm);
                                }
                            });
                            if (this.escenario.trafficIntensity != null &&
                                !this.intensidadesTransitoActivadas.includes(this.escenario.trafficIntensity.code))
                                this.escenario.trafficIntensity = null;

                            resolve();
                            if (this.escenario.trafficIntensity != null)
                                this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
                        });
                });
            },
            obtenerRevestimientosExistentes() {
                return new Promise(resolve => {
                    HttpHelper.get("rehabilitacion/horizontal/revestimiento")
                        .then(data => {
                            this.revestimientosExistente = data;
                            resolve();
                        });
                });
            },
            seleccionarUso(item) {
                this.escenario.use = item;
                this.obtenerFrecuenciasMantenimientoActivadas();
                this.obtenerIntensidadesTransitoActivadas();
            },
            seleccionarTipoLocal(item) {
                this.escenario.localType = item;
            },
            seleccionarFrecuenciaMantenimiento(item) {
                if (!this.frecuenciasMantenimientoActivadas.includes(item.code)) return;
                this.escenario.maintenanceFrequency = item;
            },
            seleccionarNecesidadHigiena(item) {
                this.escenario.needsHygiene = item;
            },
            seleccionarIntensidadTransito(item) {
                if (!this.intensidadesTransitoActivadas.includes(item.code)) return;
                this.escenario.trafficIntensity = item;
            },
            seleccionarRevestimiento(item) {
                this.escenario.existingCoating = item;
            },
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            escenarioEsCorrecto(escenario) {
                let params = [
                    escenario.use,
                    escenario.localType,
                    escenario.maintenanceFrequency,
                    escenario.needsHygiene,
                    escenario.trafficIntensity,
                    escenario.existingCoating
                ];

                let someNull = false;
                params.forEach((item) => {
                    if (item == null) someNull = true;
                });
                if (someNull) return false;

                if (!escenario.maintenanceFrequency ||
                    !this.frecuenciasMantenimientoActivadas.includes(escenario.maintenanceFrequency.code)) return false;

                if (!escenario.trafficIntensity || (this.intensidadesTransitoActivadas.length > 0 &&
                    !this.intensidadesTransitoActivadas.includes(escenario.trafficIntensity.code)))
                    return false;

                return true;
            },
        }
    }
</script>

<style scoped>
</style>